const stagingMock = {
  env: 'stagingMock',
  backendUrl: 'https://ctt-clientes.redradix.com/',
  hasDebug: false,
  hasMocks: true,
  isTest: false,
}

export default stagingMock
